import React from "react"
import { NoSettings } from "./utils/no-settings"
import { useParentSection } from "../../section/utils/use-parent-section"
import { useBlocks } from "app/regions/hooks/use-blocks"
import Stack from "@kit/design/stack"
import Label from "@kit/design/label"
import { createTheme, useInheritedTheme } from "@convertkit/editor"
import PixelSlider from "@kit/design/pixel-slider"
import { ColorInput } from "@kit/design/color-picker"
import { FontSettings } from "./utils/font-settings"
import { Expander } from "app/regions/blocks/shared/expander"
import { useSavedColors } from "hooks/use-saved-colors"

function Settings({ section }) {
  const { update, properties } = useBlocks(section?.block_id)
  const { find } = useInheritedTheme()

  const savedColors = useSavedColors()

  function handleChange(key, value) {
    update({ theme: createTheme(properties.theme, "blockquote", key, value) })
  }

  return (
    <Stack spacing={4}>
      <FontSettings
        fontFamily={find("blockquote", "fontFamily")}
        fontWeight={find("blockquote", "fontWeight")}
        onChange={handleChange}
      />

      <PixelSlider
        label="Size"
        name="fontSize"
        value={find("blockquote", "fontSize") || 0}
        onChange={value => handleChange("fontSize", Number(value))}
        min={8}
        max={50}
      />

      <Stack spacing={1}>
        <Label>Color</Label>
        <ColorInput
          name="color"
          value={find("blockquote", "color")}
          onChange={color => handleChange("color", color.hex)}
          savedColors={savedColors}
        />
      </Stack>

      <div className="-mb-4">
        <Expander label="Border">
          <PixelSlider
            label="Width"
            name="borderLeftWidth"
            value={find("blockquote", "borderLeftWidth") || 0}
            onChange={value => handleChange("borderLeftWidth", Number(value))}
            min={0}
            max={12}
          />

          <Stack spacing={1}>
            <Label>Color</Label>
            <ColorInput
              name="borderLeftColor"
              value={find("blockquote", "borderLeftColor")}
              onChange={color => handleChange("borderLeftColor", color.hex)}
              savedColors={savedColors}
            />
          </Stack>
        </Expander>
      </div>
    </Stack>
  )
}

export function BlockquoteSettings({ block_id }) {
  const section = useParentSection(block_id)

  if (!section) return <NoSettings />

  return <Settings type="blockquote" section={section} />
}
